import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  code: string;
}

const CalcStatusBadge: React.FC<Props> = ({ code }) => {
  const { t } = useTranslation();
  const status = code == null ? null : code.substring(code.indexOf('_') + 1);

  return (
    <div className={`badge-base calcstatus ${status}`}>
      <div className="badge-text">
        <span>{t(`calculatorStatus.${code}`, code)}</span>
      </div>
    </div>
  );
};

export default React.memo(CalcStatusBadge);
